import moment from 'moment';
import pluralize from 'pluralize';
import ahoy from 'ahoy.js';
import PopoverShare from './PopoverShare';
import { preventDefault } from './shared/events';
import { addFavorite, deleteFavorite } from './shared/api_request_helpers';
import { breedsToShortString } from './shared/listing_helpers';

export const listingPath = (slug) => `/available-horses/${slug}`;

function daysRemainingLabel(days_remaining) {
  if (days_remaining <= 0 || days_remaining === undefined) {
    return "Listing expired";
  } else {
    return `Listing expires in ${_.round(days_remaining)} days`;
  }
}

export default class ListingCard extends React.Component {
  state = {
    days_remaining: this.props.listing.days_remaining,
    percent_remaining: this.props.listing.percent_remaining,
    favorite:  this.props.favorite
  }

  static getDerivedStateFromProps(props) {
    const {days_remaining, percent_remaining, status} = props.listing;
    if (status === "published") {
      return {days_remaining, percent_remaining};
    }
    return null;
  }

  toggleFavorite = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.setState(({favorite}) => ({favorite: !favorite}), this.persistFavorite);
  }

  persistFavorite = () => {
    const {id} = this.props.listing;
    if (this.state.favorite) {
      addFavorite(id)
    } else {
      deleteFavorite(id);
    }
  }

  render() {
    const {listing, moved, contributor, adopter, noToggler, userType, userID, trackEvent} = this.props;
    const {
      id, slug, name, gender, breeds, age, height, location,
      status, status_reason, status_changed_at, cover,
      view_count, inquiry_count, view_percentile_3_day
    } = listing;
    const {days_remaining, percent_remaining, favorite} = this.state;
    const published = status == 'published' && days_remaining > 0;
    const notAvailable = adopter && !published;

    const trackClick = () => {
      if (trackEvent) {
        const path = window.location.pathname + window.location.search;
        ahoy.track(trackEvent, {listing_id: id, user_type: userType, user_id: userID, path});
      }
    };

    return (
      <a href={!notAvailable && slug ? listingPath(slug) : "#"}
        className={classnames("card listing-card", {moved})}
        disabled={notAvailable}
        onClick={notAvailable ? preventDefault() : trackClick}
      >
        <div className="card-body">
          <img src={cover} className="listing-card-image" alt=""/>
          {published && !noToggler && (
            <PopoverShare userType={userType} userID={userID} listing={listing}/>
          )}
          {contributor && published && (
            <div className="listing-stats" title={`${view_count} views, ${inquiry_count} inquiries`}>
              <span><i className="icon-eye"/>{view_count}</span>
              <span><i className="icon-mail"/>{inquiry_count}</span>
              {view_percentile_3_day > 75 && <span title="Top 20% of views in last 3 days">🔥</span>}
            </div>
          )}
          {adopter && (
            <i className={favorite ? "icon-heart" : "icon-heart-empty"}
              title={favorite ? "Remove from your stable" : "Add to your stable"}
              onClick={this.toggleFavorite} />
          )}
          <h5 className="card-title">{name}</h5>
          <div className="card-text">
            {location && (
              <p className="listing-data">
                {location.city}, {location.state}
              </p>
            )}
            <p className="listing-data">
              {_.compact([
                breedsToShortString(breeds),
                gender,
                (age && pluralize('year', age, true)),
                (height && `${height} HH`)
              ]).join(' / ')}
            </p>

            {notAvailable && (
              <p className="listing-data">
                <em className="listing-expiration">This horse has been adopted!</em>
              </p>
            )}

            {contributor && <>
              {published && (
                <div>
                  <div className="background-progress-bar"/>
                  <div className="progress-bar" style={{width: percent_remaining}}/>
                  <em className="listing-expiration">
                    {daysRemainingLabel(days_remaining)}
                  </em>
                </div>
              )}
              {status_reason && (
                <p className="listing-data">
                  {status == 'stalled' && 'In '}
                  {status_reason}: {moment(status_changed_at).format('M/D/YYYY')}
                </p>
              )}
            </>}
            {published && noToggler && (
              <PopoverShare userType={userType} userID={userID} listing={listing} noToggler/>
            )}
          </div>
        </div>
      </a>
    );
  }
}
